var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "footer" }, [
    _c("div", { staticClass: "container" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "iconlist" }, [
        _c("img", {
          staticClass: "logo",
          attrs: {
            src:
              "https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyh5officialWebimagese/v2/logo_yilieyun%402x.png"
          }
        }),
        _vm._v(" "),
        _c("nav", { staticClass: "nav-links" }, [
          _c("span", { on: { click: _vm.gotohome } }, [_vm._v("首页")]),
          _vm._v(" "),
          _c("span", { on: { click: _vm.gotoabout } }, [_vm._v("公司介绍")]),
          _vm._v(" "),
          _c(
            "a",
            { attrs: { href: "https://help.yilieyun.cn", target: "_blank" } },
            [_vm._v("帮助")]
          )
        ])
      ]),
      _vm._v(" "),
      _vm._m(1),
      _vm._v(" "),
      _vm._m(2)
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "code_img" }, [
      _c("img", {
        attrs: {
          src:
            "https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyh5officialWebimagese/v2/hr/pic_QR%20code%402x.png"
        }
      }),
      _vm._v(" "),
      _c("p", [_vm._v("易猎云公众号")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tel" }, [
      _c("img", {
        attrs: {
          src:
            "https://img.yilieyun.com/oss/ylyh5officialWebimagese/icon2_telephone@2x.png"
        }
      }),
      _vm._v(" "),
      _c("span", [_vm._v("400-0588-036")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "copyright" }, [
      _c("p", [
        _vm._v("© 2018-2024 易猎云（海南）科技有限公司版权所有"),
        _c("br"),
        _vm._v(" "),
        _c(
          "a",
          {
            attrs: { href: "https://beian.miit.gov.cn/", target: "view_window" }
          },
          [_vm._v("琼ICP备2021005894号-1")]
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3a664bef", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a664bef","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/footer/index.vue
// module id = null
// module chunks = 